import { render, staticRenderFns } from "./Ckeditor.vue?vue&type=template&id=6cf33ae8&scoped=true&"
import script from "./Ckeditor.vue?vue&type=script&lang=js&"
export * from "./Ckeditor.vue?vue&type=script&lang=js&"
import style0 from "./Ckeditor.vue?vue&type=style&index=0&id=6cf33ae8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf33ae8",
  null
  
)

export default component.exports